import { colors } from '../../../../../constants/colors';

export const classes = {
  icon: {
    color: colors.oxford,
    opacity: 0.6,
    cursor: 'pointer',
  },
};
